import CitiesList from './CitiesList';

export default CitiesList;



// WEBPACK FOOTER //
// ./src/scenes/Cities/components/CitiesList/index.ts